import { Dayjs } from 'dayjs';

import {
  CaWiseHotelReservation,
  CAWiseMeal,
  FireCaWiseHotelTag,
} from './types';
import { encryptHotelData, fetchHash } from './utils';

const fireHotelTag: FireCaWiseHotelTag = require('./hotelTag.js');

export const fireCaWiseHotelTag = async (
  _window: Window,
  _document: Document,
  travelId: string,
  hotelId: string,
  hotelAmount: number,
  numberOfAdalts: number,
  numberOfChildren: number,
  numberOfBabies: number,
  hotelName: string,
  mealLabel: string,
  checkInDate?: Dayjs,
  checkOutDate?: Dayjs
) => {
  const reservation: CaWiseHotelReservation = {
    productId: hotelId,
    productName: hotelName,
    checkInDate: checkInDate?.add(9, 'hour').format('YYYYMMDD') ?? '',
    checkOutDate: checkOutDate?.add(9, 'hour').format('YYYYMMDD') ?? '',
    numberOfPeople: numberOfAdalts + numberOfChildren + numberOfBabies,
    numberOfChildren: numberOfChildren + numberOfBabies,
    numberOfAdultWomen: undefined,
    numberOfAdultMen: undefined,
    repeatUserFlag: undefined,
    paymentFlag: undefined,
    amount: hotelAmount,
    facilityCode: hotelId,
    facilityName: hotelName,
    areaCode: '',
    areaName: '',
    roomNumber: undefined,
    meal: mealLabel !== '食事なし' ? CAWiseMeal.Existing : CAWiseMeal.Nothing,
    currencyType: 'JPY',
    exchangeRate: 1,
  };

  const hash = await fetchHash(travelId, 1, hotelAmount);

  const encryptedReservation = await encryptHotelData(reservation);

  return fireHotelTag(_window, _document, travelId, hash, encryptedReservation);
};
